import React, { useState } from "react";
import ItemListPopup from "../../../ui/ItemListPopup"; // ✅ Common popup wrapper
import CustomButton from "../../../ui/CommonButton";
import { ReactComponent as InformationIcon } from "../../../../assets/icons/svg/Information-icon-colorRed.svg";

interface AddGroupPopupProps {
  onClose: () => void;
  onSave: (groupName: string) => boolean; // returns false if duplicate
}

const AddGroupPopup: React.FC<AddGroupPopupProps> = ({ onClose, onSave }) => {
  const [groupName, setGroupName] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    const trimmedName = groupName.trim();
    if (!trimmedName) {
      setError("Please enter a group name.");
      return;
    }

    const success = onSave(trimmedName);
    if (!success) {
      setError("This group name has already been used. Please rename it!");
      return;
    }

    onClose();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGroupName(e.target.value);
    setError("");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
      <ItemListPopup title="Add new group" onClose={onClose}>
        <div className="flex flex-col h-full max-h-[90vh] gap-3">
          <div>
            <label className="text-sm font-medium text-gray-700">
              Group name
            </label>
            <input
              className={`w-full mt-1 px-4 py-2 text-sm border rounded-[10px] ${
                error ? "border-red-500 bg-red-50" : "border-gray-300"
              }`}
              type="text"
              placeholder="Enter group name"
              value={groupName}
              onChange={handleChange}
            />
          </div>

          {error && (
            <div className=" pt-4 border-t mt-2 mb-2">
              <div className="bg-red-100 border border-red-300 text-sm text-red-600 p-2 rounded-[8px]">
                <span className="font-medium">
                  <InformationIcon className="w-4 h-4" />
                  {error}
                </span>
              </div>
            </div>
          )}
          <div className="mt-auto pt-4 border-t flex justify-center gap-3">
            <CustomButton variant="outline" onClick={onClose}>
              Cancel
            </CustomButton>
            <CustomButton
              variant="default"
              isActive={!!groupName.trim()}
              onClick={handleSave}
              disabled={!groupName.trim()}
            >
              Save & add
            </CustomButton>
          </div>
        </div>
      </ItemListPopup>
    </div>
  );
};

export default AddGroupPopup;
